import {gsap} from "../../../libs/gsap/all.js";
import * as PIXI from "pixi.js";
import 'pixi.js/math-extras';
import {Point} from 'pixi.js';

// Constructor
export class GameH_Perso extends PIXI.Container {

  constructor(game) {
    super();

    this.game = game;

    this.position.set(460, 115);

    this.clothes = [];

    this.build();
  }

  build() {
    this.sortableChildren = true

    // add a background so we have an actual size
    this.background = new PIXI.Sprite(this.game.assets["base_perso"]);
    this.addChild(this.background);

    for (let i = 1; i <= 3; i++) {
      let bootsSprite = new PIXI.Sprite(this.game.assets["perso_boots_" + i]);
      bootsSprite.id = "boots_" + i;
      bootsSprite.alpha = 0;
      bootsSprite.zIndex = 0;
      this.clothes.push(bootsSprite);
      this.addChild(bootsSprite);

      let coatSprite = new PIXI.Sprite(this.game.assets["perso_coat_" + i]);
      coatSprite.id = "coat_" + i;
      coatSprite.alpha = 0;
      coatSprite.zIndex = 0;
      this.clothes.push(coatSprite);
      this.addChild(coatSprite);

      let glassesSprite = new PIXI.Sprite(this.game.assets["perso_glasses_" + i]);
      glassesSprite.id = "glasses_" + i;
      glassesSprite.alpha = 0;
      glassesSprite.zIndex = 10;
      this.clothes.push(glassesSprite);
      this.addChild(glassesSprite);
    }

    for (let i = 0; i < this.clothes.length; i++) {
      this.clothes[i].isActive = false;
    }

    // this.buildAnimations();
  }

  getActiveClothes() {
    let activeClothes = [];

    for (let i = 0; i < this.clothes.length; i++) {
      if (this.clothes[i].isActive) {
        activeClothes.push(this.clothes[i].id);
      }
    }

    return activeClothes;
  }

  showClothes(id) {
    for (let i = 0; i < this.clothes.length; i++) {
      if (this.clothes[i].id == id) {
        this.clothes[i].isActive = true;

        gsap.to(this.clothes[i], {
            pixi: {
              alpha: 1,
            },
            ease: "quad.out",
            duration: 0.25,
          }
        );
        break;
      }
    }
  }

  hideClothes(id) {
    for (let i = 0; i < this.clothes.length; i++) {
      if (this.clothes[i].id == id) {
        gsap.to(this.clothes[i], {
            pixi: {
              alpha: 0,
            },
            ease: "quad.out",
            duration: 0.25,
          }
        );
        break;
      }
    }
  }

  hideAllClothes() {
    for (let i = 0; i < this.clothes.length; i++) {
      this.clothes[i].alpha = 0;
      this.clothes[i].isActive = false;
    }
  }

  // buildAnimations() {
  //   this.inAnimation = gsap.fromTo(this, {
  //       pixi: {
  //         y: this.originalPosition.y + 40,
  //         alpha: 0,
  //       },
  //     }, {
  //       pixi: {
  //         y: this.originalPosition.y,
  //         alpha: 1,
  //       },
  //       ease: "quad.out",
  //       immediateRender: true,
  //       paused: true,
  //       duration: 1,
  //       onComplete: () => {
  //         this.enable();
  //       }
  //     }
  //   )
  //
  // }

  // animateIn() {
  //   if (this.inAnimation) {
  //     this.inAnimation.play();
  //   }
  // }

  // animateDropped() {
  //   gsap.killTweensOf(this);
  //
  //   gsap.to(this, {
  //       pixi: {
  //         alpha: 0,
  //       },
  //       ease: "quad.out",
  //       duration: 0.25,
  //     }
  //   );
  // }

  // animateReset(duration = 0.25) {
  //   gsap.killTweensOf(this);
  //
  //   gsap.to(this, {
  //       pixi: {
  //         alpha: 1,
  //       },
  //       ease: "quad.out",
  //       duration: duration,
  //     }
  //   );
  // }

  resetState(duration) {
    this.hideAllClothes();
    // this.animateReset(duration);
  }

  // Reset the states so we can animate in again and start over
  reset() {
    // if (this.inAnimation) {
    //   this.inAnimation.kill();
    //   this.inAnimation = null;
    // }

    this.resetState(0);

    // Rebuild the animations
    // this.buildAnimations();
  }


}
